import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Cross } from '../../Icons';

import Hint from '../Hint';

const UploadField = ({
    styles,
    name,
    labelMessage,
    onFocus,
    onChange,
    errors,
    fileName,
    handleRemoveFile,
    hint,
    sizeError,
}) => {
    const fileFiledRef = React.useRef();

    const removeFile = element => {
        element.value = null;
        element.files = null;
        handleRemoveFile();
    };

    return (
        <div className={styles.container}>
            <label className={styles.label} htmlFor={name}>
                <input
                    className={styles.input}
                    type="file"
                    name={name}
                    onFocus={onFocus}
                    onChange={onChange}
                    id={name}
                    ref={fileFiledRef}
                />
                <button type="button" className={styles.button}>
                    {fileName || <FormattedMessage id={labelMessage} />}
                </button>
                {fileName && (
                    <button
                        onClick={() => removeFile(fileFiledRef.current)}
                        type="button"
                        className={styles.removeButton}
                    >
                        <Cross className={styles.removeIcon} />
                    </button>
                )}
            </label>
            <span className={styles.errors}>
                {errors}
                {sizeError && <FormattedMessage id="jobPage.form.validation.fileSize" />}
            </span>
            {hint && <Hint id={hint} />}
        </div>
    );
};

UploadField.propTypes = {
    styles: PropTypes.shape().isRequired,
    name: PropTypes.string.isRequired,
    labelMessage: PropTypes.string.isRequired,
    onFocus: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.string,
    fileName: PropTypes.string,
    handleRemoveFile: PropTypes.func.isRequired,
    hint: PropTypes.string,
    sizeError: PropTypes.bool,
};

UploadField.defaultProps = {
    fileName: null,
    errors: null,
    hint: undefined,
    sizeError: false,
};

export default UploadField;
